var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2437 23.3333V25.6666C11.2437 26.1498 11.6354 26.5416 12.1187 26.5416C12.6019 26.5416 12.9937 26.1498 12.9937 25.6666V23.3333H11.2437Z",
    fill: "#EEE82C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6603 23.3333H15.9103V25.6666C15.9103 26.1498 16.3021 26.5416 16.7853 26.5416C17.2686 26.5416 17.6603 26.1498 17.6603 25.6666V23.3333Z",
    fill: "#EEE82C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.442 7.68208L20.7408 7.62227C21.2258 7.52517 21.7273 7.57153 22.1882 7.75608C22.9936 8.07854 23.8743 8.13878 24.7134 7.9288L24.7851 7.91085C25.3961 7.75796 25.8267 7.19008 25.8267 6.53717V4.05156C25.8267 3.19078 25.0518 2.5566 24.2463 2.75817C23.7838 2.87391 23.2983 2.84071 22.8544 2.66296L22.7691 2.62882C22.0259 2.33125 21.2172 2.25649 20.4351 2.41307L19.9117 2.51786C19.2818 2.64396 18.8267 3.21667 18.8267 3.88312V11.9941C18.8267 12.4575 19.1883 12.8333 19.6344 12.8333C20.0804 12.8333 20.442 12.4575 20.442 11.9941V7.68208Z",
    fill: "#EEE82C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.077 7V11.9942C17.077 13.3605 18.1597 14.5833 19.6347 14.5833C21.1097 14.5833 22.1924 13.3605 22.1924 11.9942V9.59928C23.0801 9.83891 24.0124 9.86691 24.917 9.67745C25.4912 10.6595 25.827 11.8465 25.827 13.125V20.3295C25.827 21.9885 24.6742 23.3333 23.2523 23.3333H14.7437V13.125C14.7437 10.7568 13.7729 8.48871 12.1567 7H17.077Z",
    fill: "#EEE82C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49365 13.125C2.49365 9.74226 4.84416 7 7.74365 7C10.6431 7 12.9937 9.74226 12.9937 13.125V23.3333H5.0983C3.65979 23.3333 2.49365 21.9728 2.49365 20.2946V13.125ZM5.11865 18.6667C5.11865 18.1834 5.5104 17.7917 5.99365 17.7917H9.49365C9.9769 17.7917 10.3687 18.1834 10.3687 18.6667C10.3687 19.1499 9.9769 19.5417 9.49365 19.5417H5.99365C5.5104 19.5417 5.11865 19.1499 5.11865 18.6667Z",
    fill: "#EEE82C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/Mailbox.29c62563152593c3e1d6d27d89758c84.svg";
export { ForwardRef as ReactComponent };